// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calc-button {
    border-radius: 10px;
    padding: 0 16px;
    transition: 0.25s ease-in-out;
    height: 48px;
    cursor: pointer;
    font-weight: 500;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 248px;
    position: relative;
}

.calc-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.calc-button:disabled:hover {
    opacity: 0.6;
}

.primary-button {
    background: var(--color-green);
    color: white;
}
.primary-button:hover {
    opacity: 0.9;
}

.outlined-button {
    background: transparent;
    border: 2px solid var(--color-green) !important;
    color: var(--color-green);
}
.outlined-button:hover {
    background: var(--color-green);
    color: white;
}

.voximplant-button {
    background: var(--color-orange);
    color: white;
    max-width: 380px;
}
.voximplant-button:hover {
    background: var(--color-orange);
    opacity: 0.9;
}

.esia-button {
    background: transparent;
    border: 2px solid #2864B8 !important;
    padding: 4px;
    min-width: 280px;
}

.esia-logo {
    padding: 0 !important;
    margin: 5.5px 2px !important;
    margin-bottom: 0 !important;
}

.esia-auth-button {
    border: none;
    padding: 0;
    display: flex !important;
    flex-direction: row !important;
    gap: 4px;
    justify-content: center;
    align-items: center;
    color: #2864B8;
    font-size: 16px;
}

.esia-button:hover {
    background-color: rgba(40, 100, 184, 0.1);
}

.esia-question-ugolok {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 4px;
    right: 4px;
    width: 14px;
    height: 14px;
    font-size: 10px;
    padding: 2px;
    border-radius: 100%;
    color: #2864B8;
    font-weight: bold;
    border: 1px solid #2864B8 !important;
}

.esia-question-msg {
    position: absolute;
    font-size: 10px;
    color: #2864B8;
    top: 100%;
    right: 0;
    margin-top: 12px;
    background: white;
    border-radius: 10px;
    padding: 10px;
    animation: ease-in-out fadeIn 125ms;
    border: 2px solid #2864B8 !important;
    z-index: 1000;
}

.red-button {
    background: var(--color-red);
    color: white;
}

@media screen and (max-width: 678px) {
    .calc-button {
        width: 100%;
        height: 58px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ui/button/style.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,+CAA+C;IAC/C,yBAAyB;AAC7B;AACA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,wBAAwB;IACxB,8BAA8B;IAC9B,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,SAAS;IACT,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mCAAmC;IACnC,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".calc-button {\n    border-radius: 10px;\n    padding: 0 16px;\n    transition: 0.25s ease-in-out;\n    height: 48px;\n    cursor: pointer;\n    font-weight: 500;\n    font-size: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-width: 248px;\n    position: relative;\n}\n\n.calc-button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.calc-button:disabled:hover {\n    opacity: 0.6;\n}\n\n.primary-button {\n    background: var(--color-green);\n    color: white;\n}\n.primary-button:hover {\n    opacity: 0.9;\n}\n\n.outlined-button {\n    background: transparent;\n    border: 2px solid var(--color-green) !important;\n    color: var(--color-green);\n}\n.outlined-button:hover {\n    background: var(--color-green);\n    color: white;\n}\n\n.voximplant-button {\n    background: var(--color-orange);\n    color: white;\n    max-width: 380px;\n}\n.voximplant-button:hover {\n    background: var(--color-orange);\n    opacity: 0.9;\n}\n\n.esia-button {\n    background: transparent;\n    border: 2px solid #2864B8 !important;\n    padding: 4px;\n    min-width: 280px;\n}\n\n.esia-logo {\n    padding: 0 !important;\n    margin: 5.5px 2px !important;\n    margin-bottom: 0 !important;\n}\n\n.esia-auth-button {\n    border: none;\n    padding: 0;\n    display: flex !important;\n    flex-direction: row !important;\n    gap: 4px;\n    justify-content: center;\n    align-items: center;\n    color: #2864B8;\n    font-size: 16px;\n}\n\n.esia-button:hover {\n    background-color: rgba(40, 100, 184, 0.1);\n}\n\n.esia-question-ugolok {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 4px;\n    right: 4px;\n    width: 14px;\n    height: 14px;\n    font-size: 10px;\n    padding: 2px;\n    border-radius: 100%;\n    color: #2864B8;\n    font-weight: bold;\n    border: 1px solid #2864B8 !important;\n}\n\n.esia-question-msg {\n    position: absolute;\n    font-size: 10px;\n    color: #2864B8;\n    top: 100%;\n    right: 0;\n    margin-top: 12px;\n    background: white;\n    border-radius: 10px;\n    padding: 10px;\n    animation: ease-in-out fadeIn 125ms;\n    border: 2px solid #2864B8 !important;\n    z-index: 1000;\n}\n\n.red-button {\n    background: var(--color-red);\n    color: white;\n}\n\n@media screen and (max-width: 678px) {\n    .calc-button {\n        width: 100%;\n        height: 58px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
